import template from './heating-type-house.jade';
import heatingTypeHouse from '../../../enums/heating-type-house';

// TODO добавить в enum Центральное газовое, Центральное угольное после обновления здесь
// https://bitbucket.org/cianmedia/cian/src/347b31ba958ede360e2e6d989f0bcef56aadc223/cian/addform/domain/model/enums.py?at=fakemaster&fileviewer=file-view-default

export default angular
    .module('cian.addForm.heatingTypeHouse', [])
    .directive('cianAfAboutObjectHeatingTypeHouse', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller: [function () {
            this.heatingTypeHouseOptions = heatingTypeHouse;
        }],
        controllerAs: 'heatingTypeHouse',
        template,
    }))
    .name;
